export const ADVANCED_INTERVIEW_TYPES = {
  READING_ASSESSMENT: 'reading-assessment',
  CODE_INTERVIEW: 'code-interview',
  CASE_STUDY: 'case-study',
  RESUME_DEEP_DIVE: 'resume-deep-dive',
  MULTI_LANGUAGE: 'multi-language',
  AVATAR: 'avatar',
  RUBRIC_BASED: 'rubric-based',
};

export const ADVANCED_INTERVIEW_TYPE_ENUM = [null, ...Object.values(ADVANCED_INTERVIEW_TYPES)];

export const ADVANCED_INTERVIEW_TYPE_LABELS = {
  [ADVANCED_INTERVIEW_TYPES.READING_ASSESSMENT]: 'Reading & Pronunciation',
  [ADVANCED_INTERVIEW_TYPES.CODE_INTERVIEW]: 'Code Interview',
  [ADVANCED_INTERVIEW_TYPES.CASE_STUDY]: 'Case Study',
  [ADVANCED_INTERVIEW_TYPES.RESUME_DEEP_DIVE]: 'Resume Deep-Dive',
  [ADVANCED_INTERVIEW_TYPES.MULTI_LANGUAGE]: 'Multi-Language',
  [ADVANCED_INTERVIEW_TYPES.AVATAR]: 'Avatar Interview',
  [ADVANCED_INTERVIEW_TYPES.RUBRIC_BASED]: 'Rubric-Based Interview',
};
